<!--
Author: TangChen
Date: 2018-10-31
Desc: 风险评测管理组件，由index.js 配置引入
-->
<template>
    <div :class="'bizcomp-risk bizcomp ' + className">
        <comp-title :title="title">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/home' }">
                    个人中心
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ title }}</el-breadcrumb-item>
            </el-breadcrumb>
        </comp-title>
        <el-row>
            <!-- <el-col :span="24" class="risklevel">
                您的风险等级： <span>{{ !$util.isEmpty(info.custrisk)?$cache.getDict('100017',info.custrisk):'未做风险评测' }}</span>
            </el-col> -->
            <el-col :span="24">
                <div class="risk-msg">
                    <div v-if="riskInfo" class="lineF clear">
                        <div v-for="(btn,index) in riskInfo" :key="index" class="boxF">
                            <div class="boxS" :class="notIE9?'':'ie-low'">
                                <div class="boxT" :class="btn.tit===info.custrisk?'yel':(Number(btn.tit-1)===Number(info.custrisk)?'blue':'')">
                                    <div class="overlay">
                                        <span>{{ $cache.getDict('100017',btn.tit) }}</span>
                                        <p>对应{{ $cache.getDict('110143',btn.tit) }}风险产品</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-if="info.custrisk.trim()" class="risk-info">
                        <!-- {{ $util.getRiskTest(info.custrisk) }} -->
                        <span>尊敬的投资者：</span><br />
                        <span>&emsp;&emsp;您的风险承受能力为：{{ $cache.getDict('100017',info.custrisk)}}，依据我司的投资者与产品、服务风险等级匹配规则，您的风险承受能力等级与我司{{ getMatchedProduct }}产品相匹配。</span>
                        <span>我司在此郑重提醒，我司向您销售的产品或提供的服务将以您的风险承受能力等级和投资品种、期限为基础，若您提供的信息发生任何重大变化，您应当及时以书面方式通知我司。我司建议您审慎评判自身风险承受能力、结合自身投资行为，认真填写投资品种、期限，并做出审慎的投资判断。</span>
                    </div>
                    <div v-else class="risk-info">
                        尚未评测
                    </div>
                </div>
            </el-col>
            <el-col :span="24" class="risk-other">
                <div class="btn-group">
                    <el-button type="primary" v-on:click.native="continueTest">
                        {{ !$util.isEmpty(info.custrisk)?"重新":"立即" }}测评
                    </el-button>
                    <el-button v-if="!$util.isEmpty(info.custrisk)" class="border-blue" v-on:click="continueRisk">
                        确定
                    </el-button>
                </div>
                <span v-if="!fn">
                    <p>为了便于金融机构更好地为您提供适当性服务，请您</p>
                    <span class="like-a" v-on:click.once="$router.push({name:'infocollection'})">前往信息补录</span>
                </span>
            </el-col>
        </el-row>
        <el-dialog title="风险变动提示" :visible.sync="dialogVisible" class="prop" width="420px">
            <div class="info-box">
                <el-alert
                    title="由于您的风险等级发生调整，系统需要您对已签订的定期投资协议或预约交易进行适当性处理，对于未处理的定期投资协议或预约交易，将不产生定投交易或预约交易申请。"
                    type="warning"
                    show-icon
                    :closable="false"
                />
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click.once="$router.push({name:'home'})">
                    前往处理
                </el-button>
                <el-button v-on:click="dialogVisible = false">
                    我已知晓
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
export default {
    name: "Risk",
    mixins: [mixin],
    props:{
        fn: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            notIE9: true,
            info: {},
            riskInfo: [{
                tit: "01"
            }, {
                tit: "02"
            }, {
                tit: "03"
            }, {
                tit: "04"
            }, {
                tit: "05"
            }],
            iswarn: "",
            dialogVisible: false
        };
    },
    created () {
        const theUA = window.navigator.userAgent.toLowerCase();
        if ((theUA.match(/msie\s\d+/) && theUA.match(/msie\s\d+/)[0]) || (theUA.match(/trident\s?\d+/) && theUA.match(/trident\s?\d+/)[0])) {
            const ieVersion = theUA.match(/msie\s\d+/)[0].match(/\d+/)[0] || theUA.match(/trident\s?\d+/)[0];
            if (ieVersion === "9") {
                this.notIE9 = false;
            }
        }
        this.info = this.$cache.getUser();
        this.iswarn = this.$route.query.iswarn || "";
        this.riskAgree();
    },
    computed:{
        getMatchedProduct(){
            let productRisk = this.$cache.getDict('110143');
            let matchedRisk = productRisk.filter(item => item.subitem <= this.info.custrisk);
            console.log(matchedRisk);
            let res = "";
            matchedRisk.forEach(item => res += item.subitemname + '风险、');
            return res.substring(0,res.length - 1);
        }
    },
    methods: {
        // 协议弹窗处理
        continueTest(){
            if(!this.fn){
                this.$router.push({name:'risktest'})
            }
            if(this.fn){
                this.$emit("risk-test-continue")
            }
        },
        riskAgree () {
            if (!this.fn && this.iswarn === "1") {
                this.dialogVisible = true;
            }
        },
        continueRisk () {
            // 风险沿用
            /* const _this = this;
            this.$util.request("acct/risksurvey/answer", { iscontinue: "0" }, "POST").then(res => {
                if (res.data) {
                    const info = _this.$cache.getUser();
                    info.riskexpired = "0";
                    info.custrisk = res.data[0].risklevel;
                    _this.$store.dispatch("setInfo", info).then(() => {
                        _this.iswarn = res.data[0].iswarn;
                        _this.riskAgree();
                    });
                }
            }); */
            if(this.fn){
                this.$emit("fn-back", true);
            }else{
                this.$router.push({name: "fund"});
            }
        }
    }
};
</script>
<style lang="scss">
@import "../../assets/css/varibles";
.bizcomp-risk {
    padding-bottom: 50px;
    .risklevel {
        font-size: $f16;
        color: $text-color1;
        text-align: center;
        line-height: 50px;
        margin-top: 30px;
        span {
            font-size: $f22;
            color: $color-b;
        }
    }
    .risk-info {
        font-size: $f16;
        color: $text-color1;
        line-height: 24px;
        margin-top: 20px;
        text-align: justify;
    }
    .risk-msg {
        position: relative;
        width: 1026px;
        margin: 20px auto 46px;
        .boxF,
        .boxS,
        .boxT,
        .overlay {
            width: 208px;
            height: 240px;
            overflow: hidden;
        }
        .overlay {
            padding: 82px 32px 40px;
        }
        .boxF:not(:first-child) .boxT {
            &:before,
            &:after {
                top: -1px;
                border-bottom: 46px solid $border-color4;
                border-left-width: 23px;
                border-right-width: 23px;
            }
        }
        .boxF .boxT {
            background-color: $bg15;
            &.yel {
                background-color: $color-b;
                &:before,
                &:after {
                    border-bottom-color: $color-a-s;
                }
            }
            &.blue {
                &:before,
                &:after {
                    border-bottom-color: $bg8;
                }
            }
        }
    }
    .risk-other {
        text-align: center;
        line-height: 30px;
        .el-button {
            width: 150px;
            &.border-blue {
                border-color: $color-b;
                color: $color-b;
            }
        }
        .el-button + .el-button {
            margin-left: 24px;
        }
        p {
            color: $text-color1;
            margin-top: 40px;
        }
    }
}
</style>
